export const OrganizationTypes = {
  Event: 'Event',
  Vendor: 'Vendor',
  Unspecified: 'Unspecified',
  UnspecifiedDivision: 'Unspecified-Division',
} as const;

export type OrganizationType =
  (typeof OrganizationTypes)[keyof typeof OrganizationTypes];

export enum UserRole {
  Anonymous = 'Anonymous',
  User = 'User',
  SuperAdmin = 'SuperAdmin',
  Manager = 'Manager',
  Employee = 'Employee',
  Owner = 'Owner',
  Accountant = 'Accountant',
  Integration = 'Integration',
  Admin = 'Admin',
  AI = 'AI',
}
